export const PREFIX_VERSION = "/v2";
export const API_URL = "https://exam-api.loigiaihay.com";
// export const API_URL = "http://localhost:3009";
export const LINK_IMG = "https://img.loigiaihay.com/";
export const URl_PAGEHOME = "https://loigiaihay.com/";
